module.exports = __webpack_public_path__ + "img/avatar_default_2.d0bb4747.svg";